<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: BadgeCustomInvoice
 */
import { AppBadge } from '../../app-badge'

defineOptions({
  name: 'BadgeCustomInvoice',
})
</script>

<template>
  <AppBadge
    color="blue"
    text="Custom invoice"
  />
</template>
